export const iconFontAwesomeCommunicationPhone = (
	<i className="fa-solid fa-phone"></i>
);
